import {
  tablePageController, translate, actionCard, openModal, actionTable,
} from 'magner';
import { sportsTourneysRead } from 'features/profile/sports/tourney/requests';
import { SportsTourney } from 'features/profile/sports/tourney/types';
import sportsTourneyConfig from 'features/profile/sports/tourney/card';

const sportsTourneysConfig = tablePageController<SportsTourney>({
  request: sportsTourneysRead,
  header: {
    title: translate('gaz.sports.tourney.table.title'),
    tabs: [
      {
        label: translate('gaz.sports.sections.tabs.title'),
        link: { name: 'sports-sections' },
        active: false,
      },
      {
        label: translate('gaz.sports.tourney.tabs.title'),
        link: { name: 'sports-tourney' },
        active: true,
      },
      {
        label: translate('gaz.sports.gto.tabs.title'),
        link: { name: 'sports-gto' },
        active: false,
      },
    ],
    actions: [
      {
        type: 'action',
        props: {
          type: 'primary',
          text: translate('gaz.sports.tourney.filters.create_new'),
        },
        emits: 'update-table',
        action: actionCard<SportsTourney>(async () => {
          try {
            await openModal<any>({
              type: 'card',
              config: sportsTourneyConfig,
              handleBeforeClose: true,
              customClass: 'modal-max-width modal-max-width__500',
              props: {
                emptyCard: true,
                entityId: null,
              },
            });
            return false;
          } catch (e) {
            return translate('gaz.sports.tourney.form.failed_creation');
          }
        }),
      },
    ],
  },

  filters: {
    fieldsShowAmount: 5,
    filtersData: {},
    actions: [],
    layout: [],
  },

  table: {
    tableLayout: 'auto',
    scrollbarAlwaysOn: true,
    emptyText: '',
    columns: [
      {
        prop: 'title',
        width: 'auto',
        label: translate('gaz.sports.tourney.table.name'),
      },
      {
        prop: 'id',
        label: translate('gaz.sports.tourney.table.actions'),
        width: 200,
        view: {
          type: 'actions',
          actions: [
            {
              type: 'action',
              emits: 'update-table',
              action: actionTable<SportsTourney>(async ({ data }) => {
                const role = (data as any).row as SportsTourney;
                try {
                  await openModal<any>({
                    type: 'card',
                    config: {
                      ...sportsTourneyConfig,
                      header: {
                        title: translate('gaz.sports.tourney.form.title_edit'),
                      },
                    },
                    customClass: 'modal-max-width modal-max-width__500',
                    handleBeforeClose: true,
                    props: {
                      emptyCard: false,
                      entityId: role.id,
                    },
                  });
                  return false;
                } catch (e) {
                  return translate('gaz.sports.tourney.form.failed_edition');
                }
              }),
              props: {
                text: translate('gaz.sports.tourney.table.edit_action'),
                type: 'primary',
                plain: true,
              },
            },
          ],
        },
      },
    ],
  },
});

export default sportsTourneysConfig;
